var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AnalyticPeriodsEnum, ApplicationEnum } from '@workalizer/shared';
import { groupByPeriod } from '@workalizer/shared/utils';
import { formatISO } from 'date-fns';
export var analyticUserActivitySummary = function (events, dateFrom, dateTo, groupBy) {
    var mappedData = groupBy === AnalyticPeriodsEnum.HOUR
        ? events.map(function (event) { return ({
            items: [event],
            date: formatISO(event.date)
        }); })
        : events.map(function (event) { return ({
            items: [event],
            date: formatISO(event.date, { representation: 'date' })
        }); });
    var eventsGroupedByPeriod = groupByPeriod(mappedData, dateFrom, dateTo, groupBy);
    var reduceEventsPeriod = function (item) {
        return Object.values(ApplicationEnum).reduce(function (acc, applicationName) {
            var count = item.items
                .filter(function (event) { return event.application_name === applicationName; })
                .reduce(function (sum, cur) { return sum + Number(cur.count); }, 0);
            acc[applicationName] = count !== null && count !== void 0 ? count : 0;
            return acc;
        }, {});
    };
    var response = eventsGroupedByPeriod.map(function (item) {
        var applicationEventCount = reduceEventsPeriod(item);
        return __assign({ name: item.date }, applicationEventCount);
    });
    return response;
};
